export default {
  container: 'container ',
  hiddenClass: 'hidden',
  siteMapfixedWidthPages: 'fixedWidthPages',
  siteMapBG: 'bg-white',
  siteMapTypo: 'max-w-container mx-auto block px-16',
  siteMapLinkBtn: 'dot bg-blue',
  breadcrumbContainer:
    'breadcrumbContainer border-t-1 border-greyLine border-solid mt-30',
  sitemapULlist: ' pl-0',
  sitemapList: 'mb-15 text-black',
  mapLinkbtn:
    'no-underline font-HelveticaNeueLight text-16 md:text-17 text-blue-lite leading-30 uppercase',
  sitemapSubULlist: ' pt-15 pb-15',
  submenuList: '',
  submenuLink:
    'text-black leading-15 font-14 no-underline block text-black-light',
  headingStyles: 'uppercase text-black-light font-DINWebPro-Bold',
  sitemapContainer: 'md:flex sitemapblock max-w-container mx-auto px-16',
  sitemapSection: 'w-full w-12/12 sitemapSection',
  sitemapLevel: [
    {
      button:
        'font-BebasNeueRegular text-20 md:text-24 text-black font-bold leading-20 uppercase block pb-10 border-b-1 border-lightGrey border-bold mt-40 mb-20 pb-10',
      link:
        'no-underline font-BebasNeueRegular font-bold text-20 md:text-24 text-black leading-20 uppercase block pb-10 border-b-1 border-lightGrey border-bold mt-40 mb-20 pb-10',
      ul: ' make-col mb-70',
      li: 'mb-15 text-black',
    },
    {
      button:
        'font-BebasNeueRegular font-bold text-16 no-underline text-blue-lite uppercase leading-24',
      link:
        'font-HelveticaNeueLight text-14 no-underline text-black leading-16',
      ul: 'mb-0 p-0 pt-15 md:pt-12 text-gray-dark',
      li: 'pb-10',
    },
    {
      button:
        'font-HelveticaNeueLight text-12 md:text-14 no-underline text-blue-lite',
      link:
        'font-HelveticaNeueLight text-14 no-underline text-black leading-16 pt-2',
      ul: 'mb-0  mt-10 md:mt-5',
      li: 'mb-10 list-none text-blue flex relative',
    },
  ],
  sitemapLinkStyles: {
    link:
      'font-HelveticaNeueLight text-14 no-underline text-black leading-16 pt-2',
    ul: 'mb-0  pl-15 md:pl-20  mt-10 md:mt-15',
    li: 'mb-17 list-none text-blue flex relative',
  },
  sitemap: {
    header: 'font-roboto-bold text-25 text-white pt-80 pb-30 pl-20 md:pl-0',
    sitemapLevelul: ' pl-0',
  },
  dividerStyle: 'block  h-px md:mb-20',
  sitemapheading:
    'text-blue text-30 md:text-40 uppercase font-BebasNeueRegular font-bold bg-lightGrey block py-25',
};
